import instance from "./api";
import {AxiosResponse} from 'axios';
import {ISupportMessage} from "../helpers/types";


export default class SupportsService {
/*    static async findAll({sort, limit, page, orderID}:any): Promise<AxiosResponse<ISupportMessage>> {
    return instance.get('supports' ,
        {
          params: {
            orderID,
            sort,
            limit,
            page
          }
        })
    }*/
    static async create(formData:any): Promise<AxiosResponse<ISupportMessage>> {
        return instance.post<ISupportMessage>(`supports` ,formData)
    }
    static async findOne(orderID:number): Promise<AxiosResponse<ISupportMessage>> {
    return instance.get<ISupportMessage>(`supports/${orderID}` )
    }

}